import { BookingPresenter } from '@shared/modules/bookings/booking.presenter';
import { CarerPresenter } from '@shared/modules/carers/carer.presenter';
import type { ClientTaskCompletion } from '@shared/modules/client-task-completions/client-task-completion';
import { ClientTaskCompletionStatusPresenter } from '@shared/modules/client-task-completions/client-task-completion-status.presenter';
import { ClientTaskScheduleEntryPresenter } from '@shared/modules/client-task-schedule-entries/client-task-schedule-entry.presenter';
import { UserPresenter } from '@shared/modules/users/user.presenter';
import { Presenter } from '@shared/presenters/presenter';

export class ClientTaskCompletionPresenter extends Presenter<ClientTaskCompletion> {

    get task(): ClientTaskScheduleEntryPresenter {
        return this.present('task.data', ClientTaskScheduleEntryPresenter);
    }

    get isCancelled(): boolean {
        return this._data.is_cancelled;
    }

    get comments(): string {
        return this._data.comments;
    }

    get booking(): BookingPresenter {
        return this.present('booking.data', BookingPresenter);
    }

    get carer(): CarerPresenter | null {
        return this._data.carer?.data ? this.present('carer.data', CarerPresenter) : null;
    }

    get carerName(): string {
        return this.carer?.name || 'Unknown Carer';
    }

    get manualCompletionBy(): UserPresenter {
        return this.present('manual_completion_by.data', UserPresenter);
    }

    get manuallyCompletedAt(): string {
        return this._get('manuallyCompletedAt', () => this.formatTimestamp(this.toDateTime('manual_completion_at')));
    }

    private get _when() {
        return this.toDateTime('when');
    }

    get when() {
        return this._get('when', () => this.formatTimestamp(this._when));
    }

    get time() {
        return this._get('time', () => this.formatTime(this._when));
    }

    get status(): ClientTaskCompletionStatusPresenter {
        return this.present('status.data', ClientTaskCompletionStatusPresenter);
    }

}
